import { getStore } from "app/store/store"
import { getCDNAbsoluteUrl } from "ui/configuration/tools/common"
import { getLogoUrlFromOptions } from "./options"

export const getLogoUrl = (useTrunkedImage: boolean, isDarkTheme: boolean): string => {
  const customLogoUrl = getLogoUrlFromOptions()
  if (customLogoUrl) {
    return customLogoUrl
  }
  const uiConfig = getStore().getState().ui.config
  if (isDarkTheme) {
    if (useTrunkedImage) {
      return getCDNAbsoluteUrl(uiConfig.images.logoSmall.darkUrl)
    } else {
      return getCDNAbsoluteUrl(uiConfig.images.logoBig.darkUrl)
    }
  } else {
    if (useTrunkedImage) {
      return getCDNAbsoluteUrl(uiConfig.images.logoSmall.lightUrl)
    } else {
      return getCDNAbsoluteUrl(uiConfig.images.logoBig.lightUrl)
    }
  }
}
